module.exports = __webpack_public_path__ + "img/zhankaishouqi.f3e0a2c4.png";